import { siteText } from '../siteText'
import type { Version } from '../types'
import { formatDuration } from './ui'

export function HumanMomentProvenance({ version }: { version: Version }) {
  // Provenance belongs to this cut. Clip-level intent may outlive a revision
  // that removes a marked moment, so it must not substitute for version data.
  const moments = version.human_moments || []
  if (!moments.length) return null
  return <section className="human-moment-provenance" aria-label="Human-marked source moments">
    <strong>Human-marked</strong>
    <ul>{moments.map(moment => <li key={moment.id} data-moment-id={moment.id} title={`Source time: ${moment.source_seconds} seconds`}>
      <span className="human-moment-time">Source {formatDuration(moment.source_seconds)}</span>
      {moment.note ? <span>{siteText(moment.note)}</span> : null}
    </li>)}</ul>
    {moments.some(moment => moment.selection_method === 'measured_context') ? <p>Included by human request.</p> : null}
  </section>
}
